import { MeiliSearchError } from "./meilisearch-error.js";
export class MeiliSearchRequestError extends MeiliSearchError {
    name = "MeiliSearchRequestError";
    constructor(url, cause) {
        super(`Request to ${url} has failed`, { cause });
    }
}
